import { useCallback } from 'preact/hooks';
import useBotRequest from '@components/chatbots/twitch/data/useBotRequest.js';

export function useJoinChannel({
  twitchUsername,
  twitchTokenValidated,
  twitchAccessToken,
}) {
  const handleBotRequest = useBotRequest({ twitchUsername, twitchAccessToken });

  return useCallback(() => {
    const url = import.meta.env.VITE_BOT_URL + '/createWebhooks';

    if (!twitchAccessToken || !twitchTokenValidated)
      return { success: false, webhooks: null };

    return handleBotRequest(url);
  }, [handleBotRequest, twitchAccessToken, twitchTokenValidated]);
}

export function useLeaveChannel({ twitchUsername, twitchAccessToken }) {
  const handleBotRequest = useBotRequest({ twitchUsername, twitchAccessToken });
  return useCallback(() => {
    const url = import.meta.env.VITE_BOT_URL + '/deleteWebhooks';
    return handleBotRequest(url);
  }, [handleBotRequest]);
}
